import { useTranslation } from 'libs/i18n';
import { IconButton, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { useFormContext } from 'modules/client/legal/forms/companyActivitiesForm';

interface Props {
  index: number;
  onRemoveActivity: (index: number) => void;
  onAddActivity: () => void;
}

export const Header = ({ index, onRemoveActivity, onAddActivity }: Props) => {
  const { t } = useTranslation();
  const { readOnly } = useFormContext();
  const isFirst = index === 0;
  return (
    <Stack alignItems="center" direction="row" spacing={12}>
      <Typography variant="bodyBold">
        {t(
          index === 0
            ? 'client.legal.companyActivities.activityHeader'
            : 'client.legal.companyActivities.otherActivityHeader'
        )}
      </Typography>

      {!readOnly && !isFirst && (
        <IconButton
          colorVariant="red"
          icon={<Icon.Minus size={16} />}
          mode="outlined"
          sizeVariant="xs"
          onClick={() => onRemoveActivity(index)}
        />
      )}

      {!readOnly && isFirst && (
        <IconButton
          icon={<Icon.Plus size={16} />}
          mode="outlined"
          sizeVariant="xs"
          onClick={onAddActivity}
        />
      )}
    </Stack>
  );
};
